import colors from 'styles/colors'

const styles = {
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'calc(1rem + 24px)',
    backgroundColor: colors.white
  },
  iconTextContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  icon: {
    fontSize: 29,
    margin: 0,
    color: colors.primary
  },
  title: {
    marginTop: 10,
    marginBottom: 6,
    fontFamily: 'Barlow',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '0.23px',
    lineHeight: '24px',
    color: colors.lightGray
  },
  text: {
    fontFamily: 'Barlow',
    fontSize: 12,
    lineHeight: '17px',
    color: colors.lightGray
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingLeft: 0,
    borderLeft: `2px solid ${colors.calypsoBlue}`,
    borderTop: `2px solid ${colors.calypsoBlue}`,
    backgroundColor: colors.white
  },
  carousel: {
    display: 'flex',
    flex: 1
  },
  slider: {
    flex: 1
  },
  button: {
    background: 'none',
    border: 'none'
  },
  sliderIcon: {
    fontSize: '13.88px',
    margin: 0,
    color: colors.primary
  },
  additionalText: {
    marginLeft: 20,
    fontFamily: 'Barlow',
    fontSize: 15,
    lineHeight: '17px',
    color: colors.lightGray
  }
}

export default styles
